import { Injectable } from '@angular/core';
import { ApiEndpointInfo } from './api-endpoint-info.model';
import { MyApp } from './enumerations';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ApiUrlService
{
    readonly defaultPageSize = 1000;

    defaultEndpointIndex = environment.defaultApiEndpoint;

    apiEndpoints: ApiEndpointInfo[] = [
        new ApiEndpointInfo(MyApp.Environment.Prod, 'https://apiv2.my1218app.com'),
        new ApiEndpointInfo(MyApp.Environment.Staging, 'https://apiv2staging.my1218app.com'),
        new ApiEndpointInfo(MyApp.Environment.Dev, 'https://localhost:5001'),
        new ApiEndpointInfo(MyApp.Environment.Test, 'https://apiv2test.my1218app.com')
    ];

    constructor() { }

    baseUrl = this.apiEndpoints.find( e => e.environment === this.defaultEndpointIndex).baseUrl;

    // =========================================================================================================================================================
    // Base URLs
    // =========================================================================================================================================================
    private get baseApiUrl(): string { return this.baseUrl + '/api/'; }
    private get baseAuthApiUrl(): string { return `${this.baseApiUrl}auth`; }
    private get baseTenantsApiUrl(): string { return `${this.baseApiUrl}tenants`; }

    // =========================================================================================================================================================
    // Authorization
    // =========================================================================================================================================================
    get loginUrl(): string { return `${this.baseAuthApiUrl}/token`; }
    get changePasswordUrl(): string { return `${this.baseAuthApiUrl}/changepassword`; }
    get forgotPasswordUrl(): string { return `${this.baseAuthApiUrl}/forgotpassword`; }
    get registerUserUrl(): string { return `${this.baseAuthApiUrl}/register`; }
    get confirmEmailUrl(): string { return `${this.baseAuthApiUrl}/confirm`; }
    get resetPasswordUrl(): string { return `${this.baseAuthApiUrl}/resetpassword`; }

    // =========================================================================================================================================================
    // Albums
    // =========================================================================================================================================================
    private get baseAlbumsApiUrl(): string { return `${this.baseApiUrl}albums`; }
    getAlbumsUrl(id: number, breadcrumbs: boolean): string { return `${this.baseAlbumsApiUrl}/${id}?includeBreadcrumbs=${breadcrumbs}`; }

    // =========================================================================================================================================================
    // Folders
    // =========================================================================================================================================================
    private get baseFoldersApiUrl(): string { return `${this.baseApiUrl}folders`; }
    getFolderUrl(id: number): string { return `${this.baseFoldersApiUrl}/${id}?includeBreadcrumbs=true`; }

    // =========================================================================================================================================================
    // Categories
    // =========================================================================================================================================================
    private get baseCategoriesApiUrl(): string { return `${this.baseApiUrl}organizations/categories`; }

    // =========================================================================================================================================================
    // Images
    // =========================================================================================================================================================
    private get baseImagesApiUrl(): string { return `${this.baseApiUrl}images`; }
    getImageUrlWithSizeUrl(imageId: number, width: number, height: number): string { return `${this.baseImagesApiUrl}/url/${imageId}/${width}/${height}/filename`; }

    // =========================================================================================================================================================
    // Members
    // =========================================================================================================================================================
    private get baseMembersApiUrl(): string { return `${this.baseApiUrl}members`; }
    addOrRemoveFavoriteUrl(imageAssetId: number): string { return `${this.baseMembersApiUrl}/favoriteImage/${imageAssetId}`; }

    // =========================================================================================================================================================
    // Organizations
    // =========================================================================================================================================================
    private get baseOrganizationsApiUrl(): string { return `${this.baseApiUrl}organizations`; }
    getOrganizationsUrl(sortField?: string, sortOrder?: MyApp.SortOrder, pageIndex = 0, pageSize = this.defaultPageSize): string
    {
        return `${this.baseOrganizationsApiUrl}?${this.getQueryParams('name', pageIndex, pageSize, sortField, sortOrder)}`;
    }
    currentOrganizationUrl(): string { return `${this.baseOrganizationsApiUrl}/current`; }
    currentOrganizationImagesUrl(): string { return `${this.baseOrganizationsApiUrl}/current/images`; }

    // =========================================================================================================================================================
    // Tenants
    // =========================================================================================================================================================
    get getAllTenantsUrl(): string { return `${this.baseTenantsApiUrl}`; }
    get getAllProductsUrl(): string { return `${this.baseTenantsApiUrl}/products`; }
    get getProductUrl(): string { return `${this.baseTenantsApiUrl}/product`; }

    // =========================================================================================================================================================
    // Helper Methods
    // =========================================================================================================================================================
    private getQueryParams(defaultSortField: string, pageIndex?: number, pageSize?: number, sortField?: string, sortOrder?: MyApp.SortOrder)
    {
        sortField = sortField ? sortField : defaultSortField;

        return `sortField=${sortField}&sortOrder=${this.getSortOrder(sortOrder)}&pageIndex=${pageIndex}&pageSize=${pageSize}`;
    }

    private getSortOrder(sortOrder?: MyApp.SortOrder): string
    {
        sortOrder = sortOrder ? sortOrder : MyApp.SortOrder.Ascending;
        return (sortOrder === MyApp.SortOrder.Ascending) ? 'asc' : 'desc';
    }

}
